define.alias("shared/components/shared/pre-boarding/social-connect/index", "media/components/shared/pre-boarding/social-connect/index");